var amdi18n={"__root":{},"__cs":{},"__da":{},"__de":{},"__es":{},"__fi":{},"__fr":{},"__hr":{},"__hu":{},"__it":{},"__ja":{},"__kk":{},"__ko":{},"__nb":{},"__nl":{},"__no":{},"__pl":{},"__pt":{},"__pt-br":{},"__ro":{},"__ru":{},"__sl":{},"__sv":{},"__th":{},"__tr":{},"__zh":{},"__zh-cn":{},"__zh-tw":{}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;